import React, { useEffect, useState } from 'react';
import { Badge, Card, Container, ListGroup } from 'react-bootstrap';
import { CursosExternosService } from '../../../../service/cursosExternos.service';
import { CursoExterno } from '../../../../service/types/cursosExternos.types';
import CursoExternoView from './CursoExternoView';

export default function MisCursosExternosList() {
  const [cursos, setCursos] = useState<CursoExterno[]>([]);
  const [cursoActivoId, setCursoActivoId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const data = await CursosExternosService.misCursosExternos();
      setCursos(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  if (cursoActivoId) {
    return (
      <Container fluid className="p-0">
        <button className="btn btn-link mb-2 p-0" onClick={() => setCursoActivoId(null)}>
          &larr; Volver a cursos externos
        </button>
        <CursoExternoView
          cursoExternoId={cursoActivoId}
          onCompletado={load}
          onCerrar={() => setCursoActivoId(null)}
        />
      </Container>
    );
  }

  return (
    <Container fluid className="p-0">
      <Card>
        <Card.Header>Cursos Externos</Card.Header>
        <Card.Body>
          <ListGroup>
            {cursos.map((curso) => (
              <ListGroup.Item
                key={curso.id}
                action
                onClick={() => setCursoActivoId(curso.id)}
                className="d-flex justify-content-between align-items-center"
              >
                <div>
                  <strong>{curso.nombre}</strong>
                  {curso.descripcion && <div className="text-muted small">{curso.descripcion}</div>}
                </div>
                <Badge bg={curso.completado ? 'success' : 'secondary'}>
                  {curso.completado ? 'Completado' : 'Pendiente'}
                </Badge>
              </ListGroup.Item>
            ))}
            {!loading && cursos.length === 0 && (
              <ListGroup.Item className="text-center text-muted">No tiene cursos externos asignados</ListGroup.Item>
            )}
          </ListGroup>
        </Card.Body>
      </Card>
    </Container>
  );
}
